export const ENVELOPE_SETUP_MODES = {
  EDITING: 'edit',
  DEFAULT: 'setup',
};
